import { ApiHttpService } from '../../services'
export const ProductDepartmentModule = {
    namespaced: true,
    state: {
        data: {
            columns: [
                { label: 'ID', field: 'id', sort: 'asc', clickable: true, width: '100' },
                { label: 'Name', field: 'name', sort: 'asc', width: '250' },
                { label: 'Description', field: 'description', sort: 'asc' },
                {
                    label: 'Status',
                    field: 'status',
                    sort: 'asc',
                    badge: true,
                    filters: [
                        { text: 'Active', value: '1' },
                        { text: 'Inactive', value: '0' },
                    ],
                    badgeFormatter: value => [true, 1, '1', 'true'].includes(value)
                        ? { label: 'Active', color: 'success' }
                        : { label: 'Inactive', color: 'secondary' },
                },
                { label: 'Sort Order', field: 'sort_order', sort: 'asc', width: '120' },
            ],
            rows: [],
        },
        multipleSelection: [],
        length: 25,
        page: 1,
        total: 1,
        searchTerm: null,
        filters: {},
        loading : false,
        getLoading : false,
        putLoading : false,
        postLoading : false,
        deleteLoading : false,
        form : {},
        initialFormData : {
            name: '',
            description: '',
            status: 1,
            sort_order: 0,
        },
        formStatus: 'create'
    },
    mutations: {
        addRequest : (state, req) => {
            state.request = {cancel : req.cancel, msg : "loading"}
            
        },
        cancelRequest : (state) => {
            state.request.cancel()
            state.loading = true
        },
        clearOldRequest(state, message) {
            state.request.msg = message;
            state.request = null;
        },
        setData(state, payload) {
            state.data = payload
        },
        loadingTrue(state) {
            state.loading = true
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        setColumns(state, payload) {
            state.data.columns = payload
        },
        setRows(state, payload) {
            state.data.rows = payload
        },
        setPage: (state, payload) => {
            state.page = payload
        },
        setTotal: (state, payload) => {
            state.total = payload
        },
        setLength: (state, payload) => {
            state.length = payload
        },
        setSearchTerm: (state, payload) => {
            state.searchTerm = payload
        },
        setSelection: (state, payload) => {
            state.multipleSelection = payload
        },
        setFilters: (state, payload) => {
            state.filters = payload
        },
        setEmptyData: (state) => {
            state.data.rows = []
        },
        LoadingFalse: (state) => {
            state.loading = false
        },

        setFormStatusCreate: (state) => {
            state.formStatus = 'create'
        },

        setFormStatusUpdate: (state) => {
            state.formStatus = 'update'
        },
        setFormRecord: (state, payload) => {
            state.form = payload
        },
    },
    actions : {
        async resetData({dispatch}, endpoint){
            dispatch('asyncGetData', endpoint)
        },
        async asyncGetData({ state, commit},endpoint) {

            const { loading, length, page, filters, searchTerm } = state
            return await new Promise((resolve, reject) => {
                if (loading === false) {
                    commit('setLoading', true)
                    commit('setRows', [])
                    const params = { length: length, page: page, term: searchTerm, filters: filters }

                    const configParams = {
                        req : "ProductDepartmentModule/req",
                        loadingTrue : "ProductDepartmentModule/loadingTrue",
                        addRequest : "ProductDepartmentModule/addRequest",
                        cancelRequest : "ProductDepartmentModule/cancelRequest",
                        clearOldRequest : "ProductDepartmentModule/clearOldRequest"
                    }

                    ApiHttpService.getRequest(endpoint, params, configParams).then((response) => {

                   
                        commit('setPage', response.data.current_page)
                        commit('setTotal', response.data.total)
                        commit('setRows', response.data.data)
                        commit('setLoading', false)
                        resolve(response.data.data)
                    }).catch(error => {
                        commit('setLoading', false)
                        reject(error)
                    })
                }
            })
        },

        async storeRecord({ commit }, payload) {
            const response = await ApiHttpService.postRequest('product-departments', payload)
            commit('setFormRecord', response.data.data || {})
            return response.data
        },

        async updateRecord(_, payload) {
            const response = await ApiHttpService.update('product-departments', payload)
            return response.data
        },

        async deleteRecord(_, rows) {
            const tokens = rows.map(row => row.hash).filter(Boolean)
            const response = await ApiHttpService.deleteRequest('product-departments', { tokens })
            return response.data
        },
    },
    getters: {
        rows: state => state.data.rows,
        data: state => state.data,
        columns: state => state.data.columns,
        selection : state => state.multipleSelection,
        loading : state => state.loading,
        page: state => state.page,
        total: state => state.total,
        length: state => state.length,
        searchTerm: state => state.searchTerm,
        filters: state => state.filters,
        req: state => state.request,
        initialFormObject: state => state.initialFormData,
        getLoading: state => state.getLoading,
        formData: state => state.form,
        formRecord: state => state.form,
        formStatus: state => state.formStatus,
        putLoading: state => state.putLoading,
        postLoading: state => state.postLoading,
        deleteLoading: state => state.deleteLoading,
    }
}



